<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title='id ? "Редактирование акции" : "Добавление акции"'
  )
  v-card
    v-container(grid-list-xl fluid)
      v-layout(wrap)
        v-flex(xs12)
          s-publish-date-status(
            :errors='errors'
            :model='item'
          )
        v-flex(xs12 sm6)
          s-datetime-picker(
            :today='false'
            :validator='errors'
            v-model='item.start_time'
            label='Дата начала'
            name='start_time'
          )
        v-flex(xs12 sm6)
          s-datetime-picker(
            :today='false'
            :validator='errors'
            v-model='item.stop_time'
            label='Дата завершения'
            name='stop_time'
          )
        v-flex(xs12)
          v-select(
              v-model='item.tags'
              label='Тэги для акции'
              multiple
              chips
              :items = 'tagsList'
              item-value='id'
              item-text='name'
              class='tag-input'
              retur-object
              type = 'array'
          )
        v-flex(xs12)
          s-sites-picker(
            :error='errors.has("site_ids")'
            :error-messages='errors.first("site_ids")'
            v-model='sites'
            multiple
            chips
          )
        v-flex(xs12)
          v-text-field(
            :error='errors.has("name")'
            :error-messages='errors.first("name")'
            v-model='item.name'
            label='Название'
          )
        v-flex(xs12)
          s-slug-input(
            :model='item'
          )
        v-flex(xs12)
          v-textarea(
            :error='errors.has("annotation")'
            :error-messages='errors.first("annotation")'
            v-model='item.annotation'
            label='Краткий текст'
            counter
          )
        v-flex(v-if="editor" xs12)
          div(class='subheading font-weight-medium mb-3') Полный текст
          ckeditor(v-model='item.body')
        v-flex(v-else xs12)
          v-textarea(
            v-model='item.body'
            :rows=15
            label='Исходный код акции'
          )
        v-flex(xs12 small)
          v-textarea(
            :error='errors.has("law_text")'
            :error-messages='errors.first("law_text")'
            v-model='item.law_text'
            :rows=15
            label='Юридическая информация'
            counter
          )
        v-flex(xs12 sm4)
          div(v-if='errors.has("picture")' :style="{ color: 'red', fontSize: '12px' }")
            div {{ errors.first("picture") }}
          s-image-upload(
            :src='item.picture_url'
            :error='errors.has("picture")'
            :error-messages='errors.first("picture")'
            v-model='item.picture'
            label='Картинка акции квадрат (МП, промо)'
          )
        v-flex(xs12 sm4)
          div(v-if='errors.has("picture_wide")' :style="{ color: 'red', fontSize: '12px' }")
            div {{ errors.first("picture_wide") }}
          s-image-upload(
            :src='item.picture_wide_url'
            :error='errors.has("picture_wide")'
            :error-messages='errors.first("picture_wide")'
            v-model='item.picture_wide'
            label='Картинка акции широкая (корп сайт)'
          )
    v-card-actions(class='large')
      v-spacer
      s-back-btn
      v-btn(
        @click='onSave'
        :loading='isLoading'
        color='primary'
        depressed
      ) Сохранить
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: ['id'],

  components: {
    Ckeditor: () => import('@/components/async/Ckeditor')
  },

  data: () => ({
    item: {},
    editor: true,
    tagsList: [
        {
          id: 'oplata100',
          name: '100% оплата'
        },
        {
          id: 'ipoteka',
          name: 'Ипотека'
        },
        {
          id: 'rassrochka',
          name: 'Рассрочка'
        },
        {
          id: 'trade-in',
          name: 'Trade-In'
        },
        {
          id: 'leasing',
          name: 'Лизинг'
        },
        {
          id: 'corp',
          name: 'Корпоративная программа'
        }
      ]
  }),

  async created() {
    if (!this.id) return
    this.updateItem()
  },

  methods: {
    async updateItem() {
      const response = await this.fetchSingle({ id: this.id })
      this.item = response.data
    },

    async onSave() {
      const data = this.item
      data.site_ids = this.sites.join(',')

      try {
        if (this.id) await this.update({ id: this.id, data })
        else await this.create({ data })

        this.$root.showSnack('Акция сохранена')
        this.$router.push({ name: 'Content.Actions.List' })
      } catch (e) {
        this.$showServerErrors(e)
      }
    },

    ...mapActions('content/actions', ['fetchSingle', 'update', 'create'])
  },

  computed: {
    sites: {
      get() {
        const site_ids = this.item.site_ids
        return site_ids ? site_ids.split(/,/).map(x => +x) : []
      },

      set(val) {
        this.item.site_ids = val.join(',')
      }
    },

    ...mapGetters('content/actions', ['isLoading'])
  }
}
</script>

<style>
.small textarea {
  font-size: 12px;
}
</style>
